import script from "./Divider.vue?vue&type=script&lang=ts&setup=true"
export * from "./Divider.vue?vue&type=script&lang=ts&setup=true"

import "./Divider.vue?vue&type=style&index=0&id=6b66cde8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b66cde8"]])

export default __exports__